module.exports = __webpack_public_path__ + "img/3a9d7f0ecdafdc8d5395898348c33196.f2c9fadc.webp";